<template>
  <Form ref="newForm" class="modalFormWrap formStyle" :model="info" :rules="rules">
    <Row v-if="info.accountType=='DESIGNER'" :gutter="16">
      <Col span="24">
        <FormItem prop="trueName" label="真实姓名" :rules="requiredRule">
          <Input type="text" placeholder="填写真实姓名，打造同行业真实人脉" v-model="info.trueName"></Input>
        </FormItem>
      </Col>
      <Col span="24">
        <FormItem prop="idNumber" label="身份证号" :rules="IDRule">
          <Input type="text" v-model="info.idNumber"></Input>
        </FormItem>
      </Col>
    </Row>
    <Row v-if="info.accountType=='ORGANIZATION'" :gutter="16">
      <Col span="11">
        <FormItem prop="trueName" label="机构全称" :rules="requiredRule">
          <Input type="text" v-model="info.trueName"></Input>
        </FormItem>
      </Col>
      <Col span="11" offset="2">
        <FormItem prop="idNumber" label="统一社会信用代码" :rules="creditCodeRule">
          <Input type="text" v-model="info.idNumber"></Input>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem prop="contact" label="联系人" :rules="requiredRule">
          <Input type="text" v-model="info.contact"></Input>
        </FormItem>
      </Col>
      <Col span="11" offset="2">
        <FormItem prop="contactJob" label="联系人职务" :rules="requiredRule">
          <Input type="text" v-model="info.contactJob"></Input>
        </FormItem>
      </Col>
    </Row>
    <Row :gutter="16" class="cityLeft">
      <Col span="24" class="cityLabel ivu-form-item-required">
        <span class="ivu-form-item-label">所在地区</span>
      </Col>
      <Col span="24">
        <Col span="8">
          <FormItem prop="locId" :label-width="0">
            <Select 
              v-model="info.locId" 
              placeholder="所在地" 
              @on-open-change="getLocList"
              @on-change="locSelect">
              <Option v-for="item in locList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="stateId" :label-width="0">
            <Select 
              v-model="info.stateId" 
              placeholder="省份/大洲" 
              @on-open-change="getStateList"
              @on-change="stateSelect">
              <Option v-for="item in stateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="cityId" :label-width="0">
            <Select 
              v-model="info.cityId" 
              placeholder="城市/国家" 
              @on-open-change="getCityList">
              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <!-- <Col span="8" v-if="info.locId==0">
          <FormItem prop="stateId" :label-width="0">
            <Select 
              v-model="info.stateId" 
              placeholder="大洲" 
              @on-open-change="getStateList"
              @on-change="stateSelect">
              <Option v-for="item in stateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8" v-if="info.locId==0">
          <FormItem prop="cityId" :label-width="0">
            <Select 
              v-model="info.cityId" 
              placeholder="国家" 
              @on-open-change="getCityList">
              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col> -->
      </Col>
    </Row>
    <template v-if="info.accountType=='DESIGNER'">
      <FormItem prop="profession" label="主职业类型（单选）">
        <div class="typeWrap">
          <span v-for="l in professionList" 
            :key="l.id" 
            class="typeItem" 
            :class="{'typeActive': info.profession==l.id}" 
            @click="selectProfession(l)">{{l.name}}</span>
        </div>
      </FormItem>
      <FormItem prop="otherProfession" label="其他职业（多选）">
        <div class="typeWrap">
          <span v-for="l in professionList" 
            :key="l.id" 
            class="typeItem" 
            :class="{'typeActive': info.otherProfession.includes(l.id+''), 'typeDisabled': info.profession==l.id}"
            @click="multipleSelect(l, 'otherProfession')">{{l.name}}</span>
        </div>
      </FormItem>
    </template>
    <FormItem v-if="info.accountType=='ORGANIZATION'" prop="profession" label="机构类型（单选）">
      <div class="typeWrap">
        <span v-for="l in professionList" 
          :key="l.id" 
          class="typeItem" 
          :class="{'typeActive': info.profession==l.id}"
          @click="selectProfession(l)">{{l.name}}</span>
      </div>
    </FormItem>
    <FormItem prop="industry" label="相关专业（多选）">
      <div class="accountType typeWrap">
        <div class="levelWrap" v-for="(l, i) in industryList" 
          :key="l.id">
          <span class="levelOne">{{l.name}}</span>
          <div class="levelTwo">
            <span v-for="m in industryList2[i]" 
              :key="m.id" 
              class="typeItem" 
              :class="{'typeActive': info.industry.includes(m.id+'')}"
              @click="multipleSelect(m, 'industry')">{{m.name}}</span>
          </div>
        </div>
      </div>
    </FormItem>
    <div class="btnWrap">
      <Button class="defaultBtn formBtn" shape="circle" :loading="submitting" @click="submit">保存并跳转至下一未填项</Button>
      <Button type="text" class="rightBtn" @click="skip">跳过此页</Button>
    </div>
  </Form>
</template>

<script>
import centerService from '@/api/center'
export default {
  data(){
    return{
      submitting: false,
      info: {},
      rules: {
        locId: [{required: true, message: "请选择所在地", trigger: 'blur,change', type: 'number'}],
        stateId: [{required: true, message: "请选择省份/大洲", trigger: 'blur,change', type: 'number'}],
        cityId: [{required: true, message: "请选择城市/国家", trigger: 'blur,change', type: 'number'}],
        profession: [{
          required: true, 
          message: "请选择职业类型", 
          validator: (rule, value) => {
            if(value==null){
              return false
            }
            return true
          },
          trigger: 'blur,change'
        }],
        industry: [{
          required: true, 
          message: "请选择相关专业",
          validator: (rule, value) => {
            if(value.length==0){
              return false
            }
            return true
          },
          trigger: 'blur,change'
        }]
      },

      requiredRule: [{required: true, message: "内容不能为空", trigger: 'blur,change'}],
      IDRule:[{
        required: true,
        message: "请输入合法的身份证号",
        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        trigger: 'blur,change'
      }],
      creditCodeRule: [{
        required: true,
        message: "请输入合法的统一社会信用代码",
        pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/,
        trigger: 'blur,change'
      }],
      // 国家
      locList: [],
      stateList: [],
      inStateList: [],
      outStateList: [],
      cityList: [],
      // 机构类型/职业类型
      professionList: [],
      // 相关专业第一级
      industryList: [],
      // 相关专业第二级
      industryList2: [],
    }
  },
  mounted(){
    this.info = Object.assign({}, this.$store.getters.userInfo)
    if(this.info.otherProfession){
      this.info.otherProfession = this.info.otherProfession.split(',')
    }else{
      this.info.otherProfession = []
    }
    if(this.info.otherProfessionName){
      this.info.otherProfessionName = this.info.otherProfessionName.split(',')
    }else{
      this.info.otherProfessionName = []
    }
    if(this.info.industry){
      this.info.industry = this.info.industry.split(',')
    }else{
      this.info.industry = []
    }
    if(this.info.industryName){
      this.info.industryName = this.info.industryName.split(',')
    }else{
      this.info.industryName = []
    }

    this.getProfessionTypes()
    this.getDesignTypes()
    this.getLocations()
    this.getLocations('state')
    this.getLocations('city')
  },
  methods:{
    // 提交信息
    submit(){
      this.$refs.newForm.validate(valid => {
        if (valid) {
          this.submitting = true
          let condition = Object.assign({}, this.info)
          condition.industry = condition.industry.join(',')
          condition.industryName = condition.industryName.join(',')
          condition.otherProfession = condition.otherProfession.join(',')
          condition.otherProfessionName = condition.otherProfessionName.join(',')

          if(condition.accountType=='DESIGNER'){
            let idNumber = condition.idNumber
            condition.birthDay = `${idNumber.substring(6, 10)}-${idNumber.substring(10, 12)}-${idNumber.substring(12, 14)}`
          }
          centerService.registerComplete(condition)
          .then(res => {
            if(res.errorNo==0){
              this.$store.commit('setUserInfo', condition)
              this.skip()
            }else{
              this.$Message.error(res.errorMessage)
            }
            this.submitting = false
          }).catch(err => {
            this.submitting = false
            // this.$Message.error(err.message)
            console.log(err.message)
            this.$Message.error('连接服务器失败，请稍后再试')
          })
        }else{
          this.$Message.error('信息未正确填写完整')
        }
      })
    },
    // 获取相关专业类型第一级
    getDesignTypes(){
      centerService.getDesignTypes()
      .then(async res => {
        if(res.errorNo==0){
          this.industryList = res.data
          for(let i=0,l=res.data.length; i<l; i++){
            this.$set( this.industryList2, i, await this.getIndustry(res.data[i].id) )
          }
        }
      })
    },
    // 获取相关专业类型第二级
    getIndustry(pid){
      return new Promise((resolve) => {
        centerService.getDesignTypes({'pid.eq': pid})
        .then(res => {
          if(res.errorNo==0){
            resolve(res.data)
          }else{
            resolve([])
          }
        }).catch(() => {
          resolve([])
        })
      })
    },
    // 获取职业类型
    getProfessionTypes(){
      centerService.getProfessionTypes({'accountType.eq': this.info.accountType})
      .then(res => {
        if(res.errorNo==0){
          this.professionList = res.data
        }
      })
    },
    // 选择主职业类型/机构类型（单选）
    selectProfession(item){
      let id = this.info.profession, name = this.info.professionName
      this.info.profession = id==item.id ? null : item.id
      this.info.professionName = name==item.name ? null : item.name
      if(this.info.accountType=='DESIGNER'){
        let list = this.info.otherProfession, i = list.indexOf(item.id)
        if(i!=-1){
          this.info.otherProfession.splice(i, 1)
          this.info.otherProfessionName.splice(i, 1)
        }
      }
      this.$refs.newForm.validateField('profession')
    },
    // 选择其他职业类型/相关专业（多选）
    multipleSelect(item, key){
      let list = this.info[key], i = list.indexOf(item.id+'')
      if(i==-1){
        this.info[key].push(item.id+'')
        this.info[`${key}Name`].push(item.name)
      }else{
        this.info[key].splice(i, 1)
        this.info[`${key}Name`].splice(i, 1)
      }
      this.$refs.newForm.validateField(key)
    },
    // 选中国家
    locSelect(){
      this.stateList = []
      this.info.stateId = ''
      this.stateSelect()
      this.$forceUpdate()
    },
    // 选中省份
    stateSelect(){
      this.cityList = []
      this.info.cityId = ''
      this.$forceUpdate()
    },
    // 获取国家列表
    getLocList(flag){
      if(flag && this.locList.length==0){
        this.getLocations('loc')
      }
    },
    // 获取省份列表
    getStateList(flag){
      if(flag){
        this.$refs.newForm.validateField('locId', valid => {
          if(!valid){
            if(this.info.locId==0 && this.outStateList.length==0 
              || this.info.locId==1 && this.inStateList.length==0){
              this.getLocations('state')
            }else{
              this.stateList = this.info.locId==0 ? this.outStateList : this.inStateList
            }
          }
        })
      }
    },
    // 获取城市列表
    getCityList(flag){
      if(flag){
        this.$refs.newForm.validateField('stateId', valid => {
          if(!valid){
            this.getLocations('city')
          }
        })
      }
    },
    // 获取位置列表
    getLocations(flag){
      let promise
      if(flag=='city'){
        promise = centerService.getLocations({'parentid.eq': this.info.stateId})
      }else if(flag=='state'){
        promise = centerService.getLocations({'parentid.eq': this.info.locId})
      }else{
        promise = centerService.getLocations()
      }
      promise.then(res => {
        if(res.errorNo==0){
          if(flag=='city'){
            this.cityList = res.data
          }else if(flag=='state'){
            this.stateList = res.data
            if(this.info.locId==0){
              this.outStateList = res.data
            }
            if(this.info.locId==1){
              this.inStateList = res.data
            }
          }else{
            this.locList = res.data
          }
        }else{
          this.$Message.error(res.errorMessage)
        }
      }).catch(() => {
        // this.$Message.error(err.message)
        this.$Message.error('连接服务器失败，请稍后再试')
      })
    },
    skip(){
      this.$emit('Skip', {key: 'majorInfo'})
    }
  }
}
</script>

<style lang="scss" scoped>
.typeWrap{
  min-height: 32px;
  border: 1px solid #898989;
  border-radius: 20px;
  display: inline-block;
  width: 100%;

  .typeItem{
    margin: 5px;
    padding: 0 8px;
    border-radius: 100px;
    cursor: pointer;
    line-height: 22px;
    display: inline-block;
  }
  .typeActive{
    background: #00b7ee;
    color: #ffffff;
    cursor: default;
    position: relative;
  }
  .typeDisabled{
    color: #a2a2a2;
    cursor: not-allowed;
    pointer-events: none;
  }
  .levelWrap{
    position: relative;
    padding-left: 150px;
    min-height: 32px;

    .levelOne{
      position: absolute;
      left: 0;
      top: 0;
      width: 150px;
      margin: 5px;
      padding: 0 8px;
      color: #00b7ee;
    }
  }
}
</style>